import AbstractValidator from "@/components/CustomForm/Validators/AbstractValidator";
import { CustomFormFieldCreateOrUpdateDto } from "@/api/appService";
import { IValidate } from "@/components/CustomForm/Validators/IValidate";
import ValidatorProperty from "@/components/CustomForm/Validators/ValidatorProperty";
import NumberValidator from "@/components/CustomForm/Validators/implements/NumberValidator";

export default class MinValueValidator
  extends AbstractValidator
  implements IValidate
{
  private minValueProperty: ValidatorProperty;
  private numberValidator = new NumberValidator("number");

  constructor(expression: string) {
    super(expression);

    let propertyValue = "";
    const regex = new RegExp("([\\d]{1,20}(\\.\\d{1,20})?)");
    if (expression && regex.test(expression)) {
      propertyValue = regex.exec(expression)![0];
    }

    this.minValueProperty = new ValidatorProperty(
      "最小值",
      propertyValue.toString()
    );
    this.minValueProperty.propertyValueValidate = (
      newValue: string | undefined
    ) => {
      if (!newValue) {
        return ["值不能为空"];
      } else if (this.numberValidator.validate(newValue)) {
        return ["必须是一个数值"];
      } else {
        return [];
      }
    };
  }

  name(): string {
    return "minValue";
  }

  displayName(): string {
    return "最小值";
  }

  isMatch(expression: string): boolean {
    return expression.startsWith(this.name());
  }

  toString(): string {
    return `${this.name()}(${this.minValue})`;
  }

  properties(): ValidatorProperty[] {
    return [this.minValueProperty];
  }

  get minValue() {
    return Number(this.minValueProperty.propertyValue);
  }

  validate(value: any): string {
    if (typeof value !== "string" && typeof value !== "number") {
      return "";
    }
    if (typeof value === "string" && !value.length) {
      return "";
    }

    let numberValue = 0;
    if (typeof value === "number") {
      numberValue = value;
    } else {
      const numberValidateResult = this.numberValidator.validate(value);
      if (numberValidateResult) {
        return numberValidateResult;
      }
      numberValue = Number(value);
    }

    if (isNaN(numberValue)) {
      return "不是一个有效的数值";
    } else if (numberValue < this.minValue) {
      return `值不能小于${this.minValue}`;
    } else {
      return "";
    }
  }
}
